async function copyToClipboard(ele) {
    console.log("onclick copy.");
    const input = ele.previousElementSibling;
    const inputShow = ele.previousElementSibling.previousElementSibling;
    input.select();
    input.setSelectionRange(0, 99999);
    const textToCopy = input.value;
    try {
      await navigator.clipboard.writeText(textToCopy);
      
      ele.children[0].innerText = "Copied!";
      if(!inputShow.classList.contains('bg--blue2--l90')){
          inputShow.classList.add('bg--blue2--l90');
      }
      if(!inputShow.classList.contains('blue2')){
          inputShow.classList.add('blue2');
      }      
    } catch (err) {
      console.error("copy err:", err);
      fallbackCopyText(textToCopy, ele);
    }
}

function fallbackCopyText(text, ele) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const success = document.execCommand('copy');
      if (success) {
        ele.children[0].innerText = "Copied!";
        if(!inputShow.classList.contains('bg--blue2--l90')){
            inputShow.classList.add('bg--blue2--l90');
        }
        if(!inputShow.classList.contains('blue2')){
            inputShow.classList.add('blue2');
        }
      } else {
        console.error("Copy Error!");
      }
    } catch (err) {
      console.error("Copy Error!!");
    } finally {
      document.body.removeChild(textArea);
    }
}

//production list 变体切换 百分比差价
function productSelectChange(ele) {
    console.log("changed.");
    var selectedOption = ele.options[ele.selectedIndex];
    
    //价格变化
    let optionPrice = selectedOption.getAttribute("data-price");
    let optionOldPrice = selectedOption.getAttribute("data-old-price");
    var priceContent = optionPrice + '<span class="old-price">' + optionOldPrice + '</span>';
    var nextPriceElement = ele.nextElementSibling;
    nextPriceElement.innerHTML = priceContent;

    //差价信息变化        
    // var count_off = parseFloat(optionOldPrice.replace(/[^\d\.]/g,'')) - parseFloat(optionPrice.replace(/[^\d\.]/g,''));
    // count_off = count_off<0?0.00:Math.round(count_off * 100) / 100;
    // var countOffStr = optionPrice.charAt(0)+count_off;
    // ele.parentElement.previousElementSibling.previousElementSibling.innerText = countOffStr;
    optionOldPrice = parseFloat(optionOldPrice.replace(/[^\d\.]/g,''));
    optionPrice = parseFloat(optionPrice.replace(/[^\d\.]/g,''));
    if(optionOldPrice>0 && optionOldPrice>optionPrice){
        var percentStr = Math.round(((optionOldPrice-optionPrice)/optionOldPrice)*100) + '% OFF';
        ele.parentElement.previousElementSibling.previousElementSibling.innerText = percentStr;
    }else{
        ele.parentElement.previousElementSibling.previousElementSibling.innerText = '';
    }

    //图片变化
    if(selectedOption.getAttribute("data-image-url") != ""){
        var imgEle = ele.parentElement.previousElementSibling;
        imgEle.setAttribute("src",selectedOption.getAttribute("data-image-url"));
    }

    //选中
    selectedOption.setAttribute("selected",true);

    //添加到购物车按钮的变体ID变化
    let optionId = selectedOption.getAttribute("data-id");
    var hiddenVariantInput = ele.parentElement.nextElementSibling.children[0].children[0];
    hiddenVariantInput.value = optionId;
}

//production list 变体切换 普通差价
function productSelectChangeDiff(ele){
  console.log("changed.");
    var selectedOption = ele.options[ele.selectedIndex];
    
    //价格变化
    let optionPrice = selectedOption.getAttribute("data-price");
    let optionOldPrice = selectedOption.getAttribute("data-old-price");
    var priceContent = optionPrice + '<span class="old-price">' + optionOldPrice + '</span>';
    var nextPriceElement = ele.nextElementSibling;
    nextPriceElement.innerHTML = priceContent;

    //差价信息变化        
    var count_off = parseFloat(optionOldPrice.replace(/[^\d\.]/g,'')) - parseFloat(optionPrice.replace(/[^\d\.]/g,''));
    //count_off = count_off<0?0.00:Math.round(count_off * 100) / 100;
    count_off = count_off<0?0:Math.round(count_off);
    var countOffStr = optionPrice.charAt(0) + count_off + ' OFF';
    ele.parentElement.previousElementSibling.children[0].children[0].innerText = countOffStr;

    //图片变化
    if(selectedOption.getAttribute("data-image-url") != ""){
        var imgEle = ele.parentElement.previousElementSibling.children[1];
        imgEle.setAttribute("src",selectedOption.getAttribute("data-image-url"));
    }

    //选中
    selectedOption.setAttribute("selected",true);

    //添加到购物车按钮的变体ID变化
    let optionId = selectedOption.getAttribute("data-id");
    var hiddenVariantInput = ele.parentElement.nextElementSibling.children[0].children[0];
    hiddenVariantInput.value = optionId;
}

function buyNowProductItem(ele) {
    var productSelectEle = ele.parentElement.previousElementSibling.children[1];
    var selectedOption = productSelectEle.options[productSelectEle.selectedIndex];
    var choosenItemId = selectedOption.getAttribute("data-id");
    window.location.href = '/cart/'+choosenItemId+':1';
}

function addToCart(buttonEl) {
    const originalText = buttonEl.textContent;
    buttonEl.textContent = 'Adding ...';
    buttonEl.disabled = true;

    const variantId = buttonEl.previousElementSibling.value;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    }).then(response => response.json())
    .then(data => {
      console.log('✅ Added to cart:  ' + data.title);
      buttonEl.textContent = '✅ Added to cart';
      
      Shopify.onCartUpdate();
    })
    .catch((error) => {
      console.error('❌ Failed add:', error);
      buttonEl.textContent = '❌ Failed add';
    }).finally(() => {
      buttonEl.textContent = originalText;
      buttonEl.disabled = false;
    });
}